export class StockInData{
    anticipated:number[];
    saleorder:number[];
    dummy:number[];
    superDummy:number[];
}